import axios from 'axios'
import NProgress from 'nprogress/nprogress.js'
import omit from 'lodash/omit'
import Promise from 'bluebird'
import { reset } from 'redux-form'
import initializers from '../../dependencies/initializers'
import { objectToFormData } from '../../helpers/global'

require('es6-promise').polyfill()

export function publicCompaniesHasErrored(bool) {
	return {
		type: 'PUBLIC_COMPANIES_HAS_ERRORED',
		hasErrored: bool
	}
}

export function publicCompaniesIsLoading(bool) {
	return {
		type: 'PUBLIC_COMPANIES_IS_LOADING',
		isLoading: bool
	}
}

export function publicCompaniesFetchDataSuccess(publicCompanies) {
	return {
		type: 'PUBLIC_COMPANIES_FETCH_DATA_SUCCESS',
		publicCompanies
	}
}

export function publicCompanyFetchDataSuccess(publicCompany) {
	return {
		type: 'PUBLIC_COMPANY_FETCH_DATA_SUCCESS',
		publicCompany
	}
}

export function publicJobFetchDataSuccess(publicJobDetail) {
	return {
		type: 'PUBLIC_JOB_FETCH_DATA_SUCCESS',
		publicJobDetail
	}
}

export function publicCompaniesFetchPaginationSuccess(pagination) {
	return {
		type: 'PUBLIC_COMPANIES_FETCH_PAGINATION_SUCCESS',
		pagination
	}
}

export function publicCompaniesGetDetailSuccess(publicCompany) {
	return {
		type: 'PUBLIC_COMPANIES_GET_DETAIL_SUCCESS',
		publicCompany
	}
}

export function publicJobGetDetailSuccess(publicJobDetail) {
	return {
		type: 'PUBLIC_JOB_GET_DETAIL_SUCCESS',
		publicJobDetail
	}
}

export function publicJobGetCustomColorSuccess(color){
	return{
		type:'PUBLIC_JOB_CUSTOM_COLOR_SUCCESS',
		color:color
	}
}

export function publicJobGetCustomImageSuccess(backgroundImage){
	return{
		type:'PUBLIC_JOB_CUSTOM_IMAGE_SUCCESS',
		backgroundImage:backgroundImage
	}
}

export function publicJobGetCustomSocialSuccess(social_media){
	return{
		type:'PUBLIC_JOB_CUSTOM_SOCIAL_SUCCESS',
		social_media:social_media
	}
}


export function publicCompaniesFetchData(params = {}) {
	return{
		type: 'PUBLIC_COMPANIES_FETCH_DATA',
		params
	}
}

export function publicCompaniesGetDetail(companySlug) {
	return (dispatch) => {
		dispatch(publicCompaniesIsLoading(true))

		return new Promise((resolve, reject) => {
			NProgress.start()
			axios({
				url: initializers.api_host+`/public/companies/${companySlug}/jobs/filter`,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then((response) => {
				let publicCompany = response.data
				dispatch(publicCompaniesGetDetailSuccess(publicCompany))
				dispatch(publicCompaniesIsLoading(false))

				NProgress.done()
			})
			.catch((error) => {
				reject(error)

				NProgress.done()

				console.error(error)

				dispatch(publicCompaniesHasErrored(true))
			})
		})
	}
}

export function publicJobGetDetail(companySlug, jobSlug) {
	return (dispatch) => {
		dispatch(publicCompaniesIsLoading(true))

		return new Promise((resolve, reject) => {
			NProgress.start()
			axios({
				url: initializers.api_host+`/public/companies/${companySlug}/jobs/${jobSlug}/filter`,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then((response) => {
				let publicJobDetail = response.data
				let socialmedia = JSON.parse(publicJobDetail.job.social_media) || []
				if (publicJobDetail.job.header_image != "null" || typeof publicJobDetail.job.header_image!='null') {
					dispatch(publicJobGetCustomImageSuccess(publicJobDetail.job.header_image))
				}

				if (socialmedia!= "null" || typeof socialmedia!='null') {
					dispatch(publicJobGetCustomSocialSuccess(socialmedia))
				}
				if (typeof publicJobDetail.job.background!='null') {
				
						if (publicJobDetail.job.background !== null ) {
							if (publicJobDetail.job.background!=="null") {
								dispatch(publicJobGetCustomColorSuccess(publicJobDetail.job.background))
							}
						
						}
				}
				
				dispatch(publicJobGetDetailSuccess(publicJobDetail))
				dispatch(publicCompaniesIsLoading(false))

				NProgress.done()
			})
			.catch((error) => {
				reject(error)

				NProgress.done()

				console.error(error)

				dispatch(publicCompaniesHasErrored(true))
			})
		})
	}
}

export function registrationHasErrored(bool) {
	return {
		type: 'REGISTRATION_HAS_ERRORED',
		hasErrored: bool
	}
}

export function registrationSaveDataError(errors) {
	return {
		type: 'REGISTRATION_SAVE_DATA_ERROR',
		errors
	}
}

export function registrationSaveData(_data, companySlug, jobSlugs ) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			NProgress.start()

			let data = objectToFormData(_data)

			axios({
				url: initializers.api_host+`/public/companies/${companySlug}/jobs/${jobSlugs}/candidate`,
				timeout: 200000,
				method: 'post',
				responseType: 'json',
				headers: {
					'Content-Type': 'multipart/form-data'
				},
				data
			})
			.then((response) => {
				NProgress.done()

				dispatch(reset('CompanyJobDetail'))
				dispatch(registrationSaveDataError({}))

				resolve(response.data)
			})
			.catch((error) => {
				NProgress.done()
				
				if (typeof error.response == "undefined") {
				console.log(error);
				}else{
					dispatch(registrationSaveDataError(error.response.data))
				}
				

				reject(error)
			})
		})
	}
}

export function publicCompaniesAddFilterPageNumber(page) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(publicCompaniesAddFilterPageNumberSuccess(page)))
		})
	}
}

export function publicCompaniesAddFilterPageNumberSuccess(page) {
	return {
		type: 'PUBLIC_COMPANIES_ADD_FILTER_PAGE_NUMBER_SUCCESS',
		page
	}
}

export function publicCompaniesFetchDataAsync(publicCompanies) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(publicCompaniesFetchDataSuccess(publicCompanies)))
		})
	}
}

export function publicCompanyFetchDataAsync(publicCompany) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(publicCompanyFetchDataSuccess(publicCompany)))
		})
	}
}

export function publicJobFetchDataAsync(publicJobDetail) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(publicJobFetchDataSuccess(publicJobDetail)))
		})
	}
}

export function publicCompaniesGetDetailAsync(publicCompany) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(publicCompaniesGetDetailSuccess(publicCompany)))
		})
	}
}

export function publicJobGetDetailAsync(publicJobDetail) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			resolve(dispatch(publicJobGetDetailSuccess(publicJobDetail)))
		})
	}
}

export function publicJobGetDetailCode(openCode) {
	return (dispatch) => {
		dispatch(publicCompaniesIsLoading(true))
		return new Promise((resolve, reject) => {
			NProgress.start()
			axios({
				url: initializers.api_host+`/public/${openCode}`,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then((response) => {
				if(response.status ==200)
				{
					let publicJobDetail = response.data
				
					dispatch(publicJobGetDetailSuccess(publicJobDetail))
					dispatch(publicCompaniesIsLoading(false))
					
					let socialmedia = JSON.parse(publicJobDetail.job.social_media) || []
					if (publicJobDetail.job.header_image != "null" || typeof publicJobDetail.job.header_image!='null') {
						dispatch(publicJobGetCustomImageSuccess(publicJobDetail.job.header_image))
					}

					if (socialmedia!= "null" || typeof socialmedia!='null') {
						dispatch(publicJobGetCustomSocialSuccess(socialmedia))
					}

					dispatch(publicJobGetDetailSuccess(publicJobDetail))
					
					if (typeof publicJobDetail.job.background!='null') {
					
							if (publicJobDetail.job.background !== null ) {
								if (publicJobDetail.job.background!=="null") {
									dispatch(publicJobGetCustomColorSuccess(publicJobDetail.job.background))
								}
							
							}
					}
					
					
					dispatch(publicCompaniesIsLoading(false))
					resolve(publicJobDetail)
					NProgress.done()
				}
				
			})
			.catch((error) => {
				dispatch(publicJobGetDetailSuccess({}))
				dispatch(publicCompaniesIsLoading(false))
				dispatch(publicJobGetCustomImageSuccess(null))
				dispatch(publicJobGetCustomSocialSuccess(null))

				dispatch(publicJobGetDetailSuccess({}))
				dispatch(publicJobGetCustomColorSuccess('#564FDB'))
				
				dispatch(publicCompaniesIsLoading(false))

				NProgress.done()
			})
		})
	}
}

export function registrationSaveDataCode(_data, openCode) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			NProgress.start()

			let data = objectToFormData(_data)

			axios({
				url: initializers.api_host+`/public/${openCode}`,
				timeout: 200000,
				method: 'post',
				responseType: 'json',
				headers: {
					'Content-Type': 'multipart/form-data'
				},
				data
			})
			.then((response) => {
				NProgress.done()

				dispatch(reset('CompanyJobDetail'))
				dispatch(registrationSaveDataError({}))

				resolve(response.data)
			})
			.catch((error) => {
				NProgress.done()
				
				if (typeof error.response == "undefined") {
				console.log(error);
				}else{
					dispatch(registrationSaveDataError(error.response.data))
				}
				

				reject(error)
			})
		})
	}
}

export function registrationTalentPoolSaveDataCode(_data, openCode) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			NProgress.start()

			let data = objectToFormData(_data)

			axios({
				url: initializers.api_host+`/public/talent-pool/${openCode}`,
				timeout: 200000,
				method: 'post',
				responseType: 'json',
				headers: {
					'Content-Type': 'multipart/form-data'
				},
				data
			})
			.then((response) => {
				NProgress.done()

				dispatch(reset('CompanyJobDetail'))
				dispatch(registrationSaveDataError({}))

				resolve(response.data)
			})
			.catch((error) => {
				NProgress.done()
				
				if (typeof error.response == "undefined") {
				console.log(error);
				}else{
					dispatch(registrationSaveDataError(error.response.data))
				}
				

				reject(error)
			})
		})
	}
}

export function publicDocumentGetJobDetail(hashCandidateIds) {
	return (dispatch) => {
		dispatch(publicCompaniesIsLoading(true))
		return new Promise((resolve, reject) => {
			NProgress.start()
			axios({
				url: initializers.api_host+`/public/upload/candidates/${hashCandidateIds}/document`,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then((response) => {
				let publicJobDetail = response.data
				
				dispatch(publicJobGetDetailSuccess(publicJobDetail))
				dispatch(publicCompaniesIsLoading(false))
				
				let socialmedia = JSON.parse(publicJobDetail.job.social_media) || []
				if (publicJobDetail.job.header_image != "null" || typeof publicJobDetail.job.header_image!='null') {
					dispatch(publicJobGetCustomImageSuccess(publicJobDetail.job.header_image))
				}

				if (socialmedia!= "null" || typeof socialmedia!='null') {
					dispatch(publicJobGetCustomSocialSuccess(socialmedia))
				}

				dispatch(publicJobGetDetailSuccess(publicJobDetail))
				
				if (typeof publicJobDetail.job.background!='null') {
				
						if (publicJobDetail.job.background !== null ) {
							if (publicJobDetail.job.background!=="null") {
								dispatch(publicJobGetCustomColorSuccess(publicJobDetail.job.background))
							}
						
						}
				}
				
				
				dispatch(publicCompaniesIsLoading(false))

				NProgress.done()
				resolve(publicJobDetail)
			})
			.catch((error) => {
				reject(error)

				NProgress.done()

				console.error(error)

				dispatch(publicCompaniesHasErrored(true))
			})
		})
	}
}

export function registrationDocumentData(_data, hashCandidateIds) {
	return (dispatch) => {
		return new Promise((resolve, reject) => {
			NProgress.start()

			let data = objectToFormData(_data)

			axios({
				url: initializers.api_host+`/public/upload/candidates/${hashCandidateIds}/document`,
				timeout: 200000,
				method: 'post',
				responseType: 'json',
				headers: {
					'Content-Type': 'multipart/form-data'
				},
				data
			})
			.then((response) => {
				NProgress.done()

				dispatch(reset('MultiUploadDoc'))
				dispatch(registrationSaveDataError({}))

				resolve(response.data)
			})
			.catch((error) => {
				NProgress.done()
				
				if (typeof error.response == "undefined") {
				console.log(error);
				}else{
					dispatch(registrationSaveDataError(error.response.data))
				}
				

				reject(error)
			})
		})
	}
}


export function publicTalentPoolGetDetailCode(openCode) {
	return (dispatch) => {
		dispatch(publicCompaniesIsLoading(true))
		return new Promise((resolve, reject) => {
			NProgress.start()
			axios({
				url: initializers.api_host+`/public/talent-pool/${openCode}`,
				timeout: 20000,
				method: 'get',
				responseType: 'json'
			})
			.then((response) => {
				if(response.status ==200)
				{
					let publicJobDetail = response.data
					
					dispatch(publicJobGetDetailSuccess(publicJobDetail))
					dispatch(publicCompaniesIsLoading(false))
					
				
					if (publicJobDetail.job.header_image != "null" || typeof publicJobDetail.job.header_image!='null') {
						dispatch(publicJobGetCustomImageSuccess(publicJobDetail.job.header_image))
					}

					

					dispatch(publicJobGetDetailSuccess(publicJobDetail))
					
					if (typeof publicJobDetail.job.background!='null') {
					
							if (publicJobDetail.job.background !== null ) {
								if (publicJobDetail.job.background!=="null") {
									dispatch(publicJobGetCustomColorSuccess(publicJobDetail.job.background))
								}
							
							}
					}
					
					
					dispatch(publicCompaniesIsLoading(false))
					resolve(publicJobDetail)
					NProgress.done()
				}
				
			})
			.catch((error) => {
				
				dispatch(publicJobGetDetailSuccess({}))
				dispatch(publicCompaniesIsLoading(false))
				dispatch(publicJobGetCustomImageSuccess(null))
				dispatch(publicJobGetCustomSocialSuccess(null))

				dispatch(publicJobGetDetailSuccess({}))
				dispatch(publicJobGetCustomColorSuccess('#564FDB'))
				
				dispatch(publicCompaniesIsLoading(false))

				NProgress.done()
			})
		})
	}
}